import script from "./AddedAccessoriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./AddedAccessoriesList.vue?vue&type=script&setup=true&lang=js"

import "./AddedAccessoriesList.vue?vue&type=style&index=0&id=df2e84a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df2e84a8"]])

export default __exports__